import React, { Component, Fragment } from 'react';
import { CloseCircleFilled, EditOutlined, QuestionCircleOutlined, CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Select, Tooltip, Spin } from 'antd';
import CPMConnection from './CPMConnection';
import { DIE } from '../../constants/componentType';
import CSMSignalsConnection from './CSMSignalsConnection';
import { PRE_LAYOUT } from '../../constants/designVendor';
import { autoReadOrWriteSignalMapping, getWriteAndReadPortList } from '../../services/LibraryHelper/SpiceModelHelper/csmCpmParseHelper';
import TreeSelect from '@/components/TreeSelect';
import { CASCADE, ROCKY } from '../../constants/pageType';
import { updateSSNPackageInfo } from '../../pages/Rocky/store/rocky/action';
import auroraDBJson from '../../services/Designs/auroraDbData';
import EditableTable from '../EditableTable';
import _ from 'lodash';
import './index.css';

const Option = Select.Option;
const OptGroup = Select.OptGroup;
const CSM = "CSM"/* , CPM = "CPM" */;
const READ = "Read"
const NONE = 'None', SUCCESS = 'Success', ERROR = 'Error', LOADING = 'Loading'

export function FileInfo({ libraryId = "", fileName = "", subckt = "", folder = "" }) {
  this.libraryId = libraryId;
  this.fileName = fileName;
  this.subckt = subckt;
  this.folder = folder;
}

const tableColumns = [{
  title: 'PKG Port / Node',
  dataIndex: 'pin',
  width: '50%'
}, {
  title: 'CPM Node',
  dataIndex: 'node',
  width: '50%',
}];

class CPMCSMContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectFile: {},
      PowerNets: [],
      ReferenceNets: [],
      cpmVisible: false,
      csmVisible: false,
      subcktList: [],
      canvasFile: {},
      readSelectFile: new FileInfo({}),
      readSubcktList: [],
      isUpdateCSMValue: false,
      loading: false,
      autoMatchStatus: NONE,
      autoMatchSpan: '',
      pins: this.props.pins || [],
      pairs: [],
      nodes: [],
    }
  }

  componentDidMount = () => {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    this.initData()
    this.getPackageChannelInfo()
  }

  initData = async () => {
    const { packageId, info, product, targetPkg } = this.props;
    this.setState({
      loading: true
    })
    let PowerNets = [], ReferenceNets = [], dieComponent = null;
    if (product === CASCADE) {
      const powerDomain = targetPkg.content
      PowerNets.push(...powerDomain.PowerNets);
      ReferenceNets.push(...powerDomain.ReferenceNets)
      if (!dieComponent) {
        dieComponent = powerDomain.Components.find(item => item.usage === DIE);
      }
      this.setState({
        autoMatchStatus: LOADING,
        autoMatchSpan: 'Reading CPM content.'
      })
    } else if (product === ROCKY) {
      const packagePDN = this.props.packageVerificationConstructor.getPackagePDN(packageId) || {}
      const pkgInfo = await this.props.PackagePCBPdnInfo.getPCBPackagePdnInfo(packagePDN.id) || {};//package pdn id
      const powerDomains = pkgInfo.content && pkgInfo.content.powerDomains ? pkgInfo.content.powerDomains : []
      for (let powerDomain of powerDomains) {
        PowerNets.push(...powerDomain.PowerNets);
        ReferenceNets.push(...powerDomain.ReferenceNets)
        if (!dieComponent) {
          dieComponent = powerDomain.Components.find(item => item.usage === DIE);
        }
      }
    }
    PowerNets = [...new Set(PowerNets)];
    ReferenceNets = [...new Set(ReferenceNets)];
    const _info = JSON.parse(JSON.stringify(info || {}));
    const selectFile = { libraryId: _info.libraryId, fileName: _info.fileName, subckt: _info.subckt };
    const writeSelectFile = _info.writeSelectFile ? _info.writeSelectFile : new FileInfo({ ..._info });
    const readSelectFile = _info.readSelectFile ? _info.readSelectFile : new FileInfo({});
    this.setState({
      PowerNets,
      ReferenceNets,
      component: dieComponent ? dieComponent.name : null,
      info: _info,
      selectFile: { ...selectFile },
      csmPairs: _info.csmPairs || [],
      cpmPairs: _info.cpmPairs || [],
      triPairs: _info.cpmConfig ? _info.cpmConfig.triPairs : [],
      transforms: _info.cpmConfig ? _info.cpmConfig.transforms : null,
      canvasFile: { ...selectFile },
      writeSelectFile: { ...writeSelectFile },
      readSelectFile: { ...readSelectFile },
      isUpdateCSMValue: false,
      loading: false,
      pairs: this.initPairs(true)
    }, () => {
      this.getFile(writeSelectFile);
      this.getFile(readSelectFile, READ)
    })
  }

  getTableColumns = () => {
    const { nodes } = this.state;
    const columns = [...tableColumns];
    columns[0].render = (text) => {
      const info = text ? text.split('-') || [] : [];
      let title = '';
      if (info.length > 1) {
        const port = info[1];
        title = !isNaN(port) ? `${info[0]} - Port ${port}` : `${info[0]} - ${port}`;
      } else {
        const port = info[0];
        title = !isNaN(port) ? `Port ${port}` : port;
      }
      return <span className='netlist-port-title' title={title}>{title}</span>
    };
    columns[1].onCell = (record) => {
      return {
        edit: 'select',
        options: nodes,
        record,
        dataIndex: 'node',
        allowClear: true,
        dropdownMenuClassName: 'netlist-model-dropdown',
        getPopupContainer: document.getElementById("root"),
        handleSave: this.connectPinAndNode,
        handleClear: this.splitPinAndNodes
      }
    }
    return columns;
  }

  initPairs(isInit) {
    const { info = {} } = this.props;
    const { pins = [] } = this.state;
    if (Array.isArray(pins)) {
      const _pairs = pins.map(pin => {
        return { pin, node: '' }
      })
      if (isInit && info.pairs && info.pairs.length) {
        _pairs.forEach(item => {
          const findP = info.pairs.find(it => it.pin === item.pin);
          if (findP) {
            item.node = findP.node || "";
            if (typeof findP.index === 'number' || findP.index > -1) {
              item.index = findP.index;
            }
          }
        })
      }
      return _pairs;
    } else {
      return [];
    }
  }

  connectPinAndNode = (record, prevRecord) => {
    const { pairs, nodes } = this.state;
    let _pairs = [...pairs], _nodes = [...nodes];
    const pinIndex = pairs.findIndex(item => item.pin === record.pin);
    if (_pairs[pinIndex].node) {
      _nodes.push(_pairs[pinIndex].node);
    }
    _pairs[pinIndex].node = record.node;
    this.setState({
      pairs: _pairs,
      nodes: _nodes.filter(item => item !== record.node)
    })
  }

  splitPinAndNodes = (record) => {
    const { pairs, nodes } = this.state;
    let _pairs = [...pairs], _nodes = [...nodes];
    const splitIndex = _pairs.findIndex(item => item.pin === record.pin);
    if (_pairs[splitIndex].node) {
      _nodes.push(_pairs[splitIndex].node);
      _pairs[splitIndex].node = '';
      delete _pairs[splitIndex].index
      this.setState({
        pairs: _pairs,
        nodes: _nodes.sort()
      })
    }
  }

  getPackageChannelInfo = () => {
    const { rockyPackageInfo, packageChannelId, pcb, channelId, pcbChannelInfo, preLayoutId } = this.props;
    let getChannelId = null, getPackageChannelId = null, getPCBPreLayoutId = null
    if (pcb && pcb.vendor !== PRE_LAYOUT && channelId && (
      !pcbChannelInfo
      || !Object.keys(pcbChannelInfo).length
    )) {
      getChannelId = channelId;
    } else if (pcb && pcb.vendor === PRE_LAYOUT && channelId && (!preLayoutId || preLayoutId !== pcb.id)) {
      getPCBPreLayoutId = pcb.id
    }

    if (packageChannelId && (
      !rockyPackageInfo
      || !Object.keys(rockyPackageInfo).length
      || rockyPackageInfo.id !== packageChannelId)) {
      //get package channel info
      getPackageChannelId = packageChannelId;
    }
    if (getPackageChannelId || getChannelId) {
      this.props._getPCBAndPackageChannelInfo(getChannelId, getPackageChannelId, getPCBPreLayoutId)
    }
  }

  getModel = async (type) => {
    const { selectFile, csmPairs, cpmPairs, canvasFile, triPairs, transforms, readSelectFile, writeSelectFile, isUpdateCSMValue, pairs } = this.state;
    const { product } = this.props
    let cpmExist = false;
    if (product === CASCADE && selectFile && selectFile.libraryId && ((cpmPairs && cpmPairs.length) || (pairs && pairs.length))) {
      cpmExist = true
    } else if ((canvasFile && selectFile && canvasFile.libraryId === selectFile.libraryId && canvasFile.fileName === selectFile.fileName)) {
      cpmExist = true;
    }

    let _cpmPairs = [...cpmPairs], _triPairs = triPairs, _transforms = transforms, _csmPairs = csmPairs, _pairs = [...pairs];
    if (!cpmExist) {
      _cpmPairs = [];
      _triPairs = [];
      _transforms = null;
      _csmPairs = [];
      _pairs = [];
    } else if (writeSelectFile && writeSelectFile.libraryId && writeSelectFile.subckt
      && readSelectFile && readSelectFile.libraryId && readSelectFile.subckt) {
      let autoType = null;
      let csmSignalList = [], readPadList = [], padList = [];
      _csmPairs.forEach(it => {
        const { csmSignal, pad, readPad } = it;
        csmSignal && csmSignalList.push(csmSignal)
        pad && padList.push(pad)
        readPad && readPadList.push(readPad)
      });
      if (csmSignalList.length && padList.length && !readPadList.length) {
        autoType = 'read'
      } else if (csmSignalList.length && readPadList.length && !padList.length) {
        autoType = 'write'
      }
      if (autoType) {
        let portList = await getWriteAndReadPortList(writeSelectFile, readSelectFile, product);
        const { newSignalMapping } = autoReadOrWriteSignalMapping(_csmPairs, portList);
        _csmPairs = newSignalMapping;
      }
    }

    const _info = {
      ...selectFile,
      writeSelectFile: writeSelectFile,
      readSelectFile: readSelectFile,
      csmPairs: _csmPairs,
      cpmPairs: _cpmPairs,
      pairs: _pairs,
      cpmConfig: {
        triPairs: _triPairs,
        transforms: _transforms
      }
    }
    if (type === "CPM") {
      delete _info.csmPairs;
    }
    return _info;
  }

  changeSelectModel = (key, modelType) => {
    const { product } = this.props
    if (product === CASCADE) {
      if (key && key.id) {
        const { id: libraryId, name: fileName } = key
        const { selectFile, subcktList, writeSelectFile } = this.state;
        if (writeSelectFile && writeSelectFile.libraryId === libraryId) {
          return;
        }
        let _selectFile = { ...selectFile }, updateSelectFile = false;
        let _subcktList = [...subcktList], _writeSelectFile = { ...writeSelectFile }
        let updateFileInfo = { libraryId, fileName, subckt: "" };
        if (this.getIsCPMUpdate(selectFile, writeSelectFile)) {
          _selectFile = { ...updateFileInfo }
          updateSelectFile = true;
        }
        _writeSelectFile = { ...updateFileInfo };
        _subcktList = []
        this.clearCsmPairs(modelType)
        this.setState({
          selectFile: _selectFile,
          subcktList: _subcktList,
          writeSelectFile: _writeSelectFile,
          isUpdateCSMValue: true,
          autoMatchStatus: LOADING,
          autoMatchSpan: 'Automatically matching CPM content by Pin Number.',
          pairs: this.initPairs(),
          cpmPairs: [],
          triPairs: [],
          transforms: null,
        }, () => {
          this.getFile({ ...updateFileInfo }, modelType, updateSelectFile, true, true);
        });
      } else {
        // clear data
        const { selectFile, subcktList, writeSelectFile } = this.state;
        let _selectFile = { ...selectFile };
        let _subcktList = [...subcktList], _writeSelectFile = { ...writeSelectFile }
        if (_writeSelectFile.subckt && selectFile.libraryId === _writeSelectFile.libraryId && selectFile.fileName === _writeSelectFile.fileName && selectFile.subckt === _writeSelectFile.subckt) {
          _selectFile = new FileInfo({})
        }
        _writeSelectFile = new FileInfo({})
        _subcktList = [];
        this.setState({
          selectFile: _selectFile,
          subcktList: _subcktList,
          writeSelectFile: _writeSelectFile,
          isUpdateCSMValue: true,
          autoMatchStatus: NONE,
          autoMatchSpan: '',
          pairs: this.initPairs(),
          cpmPairs: [],
          triPairs: [],
          transforms: null,
        });
        this.clearCsmPairs(modelType)
      }
    } else {
      if (key && key.id) {
        const { id: libraryId, fileName } = key
        const { onDieSpiceList } = this.props;
        const currentFolder = onDieSpiceList.find(item => item.id === libraryId);
        if (currentFolder) {
          const { selectFile, readSelectFile, readSubcktList, subcktList, writeSelectFile } = this.state;
          let _selectFile = { ...selectFile }, updateSelectFile = false;
          let _readSelectFile = { ...readSelectFile }, _subcktList = [...subcktList], _readSubcktList = [...readSubcktList], _writeSelectFile = { ...writeSelectFile }
          let updateFileInfo = { libraryId, fileName, subckt: "", folder: currentFolder.name };
          if (modelType === READ) {
            if (this.getIsUpdate(selectFile, readSelectFile, writeSelectFile)) {
              _selectFile = { ...updateFileInfo }
              updateSelectFile = true;
            }
            _readSelectFile = { ...updateFileInfo };
          } else {
            if (this.getIsUpdate(selectFile, writeSelectFile)) {
              _selectFile = { ...updateFileInfo }
              updateSelectFile = true;
            }
            _writeSelectFile = { ...updateFileInfo };
            _subcktList = []
          }
          this.clearCsmPairs(modelType)
          this.setState({
            selectFile: _selectFile,
            subcktList: _subcktList,
            readSelectFile: _readSelectFile,
            readSubcktList: _readSubcktList,
            writeSelectFile: _writeSelectFile,
            isUpdateCSMValue: true
          }, () => {
            this.getFile({ ...updateFileInfo }, modelType, updateSelectFile, true);
          });
        }
      } else {
        // clear data
        const { selectFile, readSelectFile, readSubcktList, subcktList, writeSelectFile } = this.state;
        let _selectFile = { ...selectFile };
        let _readSelectFile = { ...readSelectFile }, _subcktList = [...subcktList], _readSubcktList = [...readSubcktList], _writeSelectFile = { ...writeSelectFile }
        if (modelType === READ) {
          if (_readSelectFile.subckt && selectFile.libraryId === _readSelectFile.libraryId && selectFile.fileName === _readSelectFile.fileName && selectFile.subckt === _readSelectFile.subckt) {
            if (_writeSelectFile.libraryId && _writeSelectFile.fileName && _writeSelectFile.subckt) {
              _selectFile = { ..._writeSelectFile }
            } else {
              _selectFile = new FileInfo({})
            }

          }
          _readSelectFile = new FileInfo({})
          _readSubcktList = [];
        } else {
          if (_writeSelectFile.subckt && selectFile.libraryId === _writeSelectFile.libraryId && selectFile.fileName === _writeSelectFile.fileName && selectFile.subckt === _writeSelectFile.subckt) {
            if (_readSelectFile.libraryId && _readSelectFile.fileName && _readSelectFile.subckt) {
              _selectFile = { ..._readSelectFile }
            } else {
              _selectFile = new FileInfo({})
            }
          }
          _writeSelectFile = new FileInfo({})
          _subcktList = [];
        }
        this.setState({
          selectFile: _selectFile,
          subcktList: _subcktList,
          readSelectFile: _readSelectFile,
          readSubcktList: _readSubcktList,
          writeSelectFile: _writeSelectFile,
          isUpdateCSMValue: true
        });
        this.clearCsmPairs(modelType)
      }
    }
  }

  changeReadSelectModel = (key, modelType) => {
    const [libraryId, fileName] = key ? key.split("::") : [];
    const { onDieSpiceList } = this.props;
    const currentFolder = onDieSpiceList.find(item => item.id === libraryId);
    if (currentFolder) {
      const { selectFile, readSelectFile, readSubcktList, subcktList, writeSelectFile } = this.state;
      let _selectFile = { ...selectFile }, updateSelectFile = false;
      let _readSelectFile = { ...readSelectFile }, _subcktList = [...subcktList], _readSubcktList = [...readSubcktList], _writeSelectFile = { ...writeSelectFile }
      let updateFileInfo = { libraryId, fileName, subckt: "", folder: currentFolder.name };
      if (modelType === READ) {
        if (this.getIsUpdate(selectFile, readSelectFile, writeSelectFile)) {
          _selectFile = { ...updateFileInfo }
          updateSelectFile = true;
        }
        _readSelectFile = { ...updateFileInfo };
      } else {
        if (this.getIsUpdate(selectFile, writeSelectFile)) {
          _selectFile = { ...updateFileInfo }
          updateSelectFile = true;
        }
        _writeSelectFile = { ...updateFileInfo };
        _subcktList = []
      }
      this.clearCsmPairs(modelType)
      this.setState({
        selectFile: _selectFile,
        subcktList: _subcktList,
        readSelectFile: _readSelectFile,
        readSubcktList: _readSubcktList,
        writeSelectFile: _writeSelectFile,
        isUpdateCSMValue: true
      }, () => {
        this.getFile({ ...updateFileInfo }, modelType, updateSelectFile, true);
      });
    }
  }

  clearCsmPairs = (modelType) => {
    const _csmPairs = this.state.csmPairs.map(item => {
      if (modelType === READ) {
        item.readPad = ""
      } else {
        item.pad = "";
        item.in = "";
      }
      if (!item.pad && !item.in && !item.readPad) {
        item.csmSignal = "";
      }
      return item;
    })
    this.setState({
      csmPairs: _csmPairs
    })
  }

  getFile = async (file = {}, modelType, isUpdate, isGetCSM, autoMatch = false) => {
    const { product } = this.props
    const { libraryId, fileName, subckt, folder } = file;
    if (!libraryId || !fileName) {
      if (product === CASCADE && modelType !== READ) {
        this.setState({
          autoMatchStatus: NONE,
          autoMatchSpan: ''
        })
      }
      return;
    }
    const model = await this.props.getCSMCPMSpiceModelList({ libraryId, fileName });
    // if (product === CASCADE  ) {
    //   this.autoSetPairsByPinNumber(model, autoMatch)
    // }
    if (!model || !model.model || !model.model.CSM) {
      if (modelType === READ) {
        this.setState({
          readSubcktList: []
        })
      } else {
        this.setState({
          subcktList: []
        })
      }
      return;
    }
    let subcktList = [], _subckt = ""
    if (product === CASCADE) {
      subcktList = JSON.parse(JSON.stringify(model.model.CSM));
      if (subckt) {
        _subckt = subcktList.find(item => item.name === subckt);
      }
      if (!_subckt) {
        _subckt = subcktList.length === 1 ? subcktList[0] : "";
      }
    } else {
      subcktList = model.model.CSM.map(item => item.name);
      if (subckt) {
        _subckt = subcktList.find(item => item === subckt);
      }
      if (!_subckt) {
        _subckt = subcktList.length === 1 ? subcktList[0] : (subcktList.find(item => item.match(/CSM/ig)) || "");
      }
    }

    const { selectFile } = this.state;
    let updateSelectFileInfo = product === CASCADE ? { libraryId, fileName, subckt: _subckt.name || "" } : { libraryId, fileName, subckt: _subckt, folder };
    if (modelType === READ) {
      this.setState({
        readSelectFile: { ...updateSelectFileInfo },
        readSubcktList: subcktList,
        selectFile: isUpdate ? { ...updateSelectFileInfo } : selectFile
      })
    } else {
      const { pairs } = this.state
      const nodes = _subckt ? _subckt.ports || [] : []
      const _nodes = nodes.filter(item => !pairs.map(pair => pair.node).includes(item))
      this.setState({
        subcktList,
        writeSelectFile: { ...updateSelectFileInfo },
        selectFile: isUpdate ? { ...updateSelectFileInfo } : selectFile,
        nodes: _nodes
      })
    }
  }

  getIsUpdate = (selectFile, fileInfo, firstFileInfo) => {
    if (!selectFile || !selectFile.libraryId || !selectFile.subckt) {
      return true
    }
    if (selectFile.libraryId === fileInfo.libraryId && selectFile.fileName === fileInfo.fileName && selectFile.subckt === fileInfo.subckt) {
      if (firstFileInfo && selectFile.libraryId === firstFileInfo.libraryId && selectFile.fileName === firstFileInfo.fileName && selectFile.subckt === firstFileInfo.subckt) {
        return false
      }
      return true
    }
    return false
  }

  getIsCPMUpdate = (selectFile, fileInfo) => {
    if (!selectFile || !selectFile.libraryId || !selectFile.subckt) {
      return true
    }
    if (selectFile.libraryId === fileInfo.libraryId && selectFile.fileName === fileInfo.fileName && selectFile.subckt === fileInfo.subckt) {
      return true
    }
    return false
  }

  changeSelectModelSubckt = (subckt, modelType) => {
    const { product } = this.props
    const { readSelectFile, writeSelectFile, selectFile, subcktList } = this.state;
    if (writeSelectFile && writeSelectFile.subckt === subckt) {
      return;
    }
    if (modelType === READ) {
      let _selectFile = this.getIsUpdate(selectFile, readSelectFile, writeSelectFile) ? { ...selectFile, subckt } : { ...selectFile }
      let _readSelectFile = readSelectFile || {};
      this.setState({
        readSelectFile: { ..._readSelectFile, subckt },
        selectFile: { ..._selectFile },
        isUpdateCSMValue: true
      });
    } else {
      let _selectFile = (product === CASCADE ? this.getIsCPMUpdate(selectFile, writeSelectFile) : this.getIsUpdate(selectFile, writeSelectFile)) ? { ...selectFile, subckt } : { ...selectFile }
      let _writeSelectFile = writeSelectFile || {};
      if (product === CASCADE) {
        const _subckt = subcktList.find(item => item.name === subckt)
        if (_subckt) {
          this.setState({
            nodes: _subckt.ports || [],
          })
        }
      }
      this.setState({
        writeSelectFile: { ..._writeSelectFile, subckt },
        selectFile: { ..._selectFile },
        isUpdateCSMValue: true,
        pairs: this.initPairs()
      });
    }
    this.clearCsmPairs()
  }

  openCPMConnection = (e, visible) => {
    e && e.stopPropagation();
    this.setState({
      cpmVisible: visible
    })
  }

  openCSMMapping = (e, visible) => {
    e && e.stopPropagation()
    this.setState({
      csmVisible: visible
    })
  }

  saveCPMPinMapping = ({ cpmPairs, triPairs, transforms, canvasFile, csmPairs }) => {
    const { product } = this.props
    if (product === CASCADE && !_.isEqual(cpmPairs, this.state.cpmPairs)) {
      const { PowerNets, ReferenceNets, component } = this.state;
      const { packageId } = this.props;
      const cpmPins = cpmPairs.filter(item => [...PowerNets, ...ReferenceNets].includes(item.net));
      const ports = this.props.getDiePortsByCPM({
        packageId,
        component,
        PowerNets,
        ReferenceNets,
        cpmPins
      })
      const powerNet = PowerNets && PowerNets.length ? PowerNets[0] : null
      const pinNodeMap = new Map();
      const portList = []
      ports.forEach(p => {
        const pin = `${powerNet}-${p.portName || p.port}`;
        portList.push(pin)
        pinNodeMap.set(pin, p.portName || p.port);
      });
      const pins = [...portList, ...(ReferenceNets || [])]
      this.setState({
        pins
      }, () => {
        const { pairs: prevPairs = [], nodes: prevNodes = [] } = this.state
        let _nodes = [...prevNodes];
        prevPairs.forEach(item => {
          if (item.node) {
            _nodes.push(item.node)
          }
        })
        const pairs = this.initPairs();
        pairs.forEach(item => {
          if (!item.node && pinNodeMap.has(item.pin)) {
            item.node = pinNodeMap.get(item.pin);
          }
        });
        const nodes = _nodes.filter(item => !pairs.map(pair => pair.node).includes(item))
        this.setState({
          pairs,
          nodes
        });
      })
    }

    this.setState({
      cpmPairs,
      triPairs,
      transforms,
      canvasFile,
      csmPairs
    })
  }

  saveCSMPairs = (csmPairs) => {
    this.setState({
      csmPairs,
      isUpdateCSMValue: false
    })
  }

  autoSetPairsByPinNumber = (file, autoMatch) => {
    if (!file || !file.model || !file.model.CPM || !file.model.CPM.models) {
      this.setState({
        autoMatchStatus: ERROR,
        autoMatchSpan: `${ERROR}: Reading CPM failed. Please select another file.`
      })
      return;
    }

    const nodes = JSON.parse(JSON.stringify(file.model.CPM.models));
    const powerNodes = [], refNodes = []
    nodes.forEach(item => {
      if (item.type === 'Power') {
        powerNodes.push(item)
      } else {
        refNodes.push(item)
      }
    })
    const { cpmPairs: _cpmPairs } = this.state
    if (!autoMatch) {
      this.setState({
        autoMatchStatus: SUCCESS,
        autoMatchSpan: `${SUCCESS}: There are ${nodes.length} Nodes in the CPM, and ${_cpmPairs.length} Nodes are successfully matched.`
      })
      return
    }
    const { packageId } = this.props;
    const { component, PowerNets, ReferenceNets } = this.state;
    const chipInfo = auroraDBJson.getComponent(packageId, component);
    if (!chipInfo || !chipInfo.pins) {
      return;
    }

    const powerSet = new Set(PowerNets.map(net => net.toLowerCase()));
    const refSet = new Set(ReferenceNets.map(net => net.toLowerCase()));

    const usedNodeIndexes = new Set();
    const cpmPairs = [];
    const nodeKeywordMap = {
      Power: new Map(),      // keyword => Set of node entries
      Ground: new Map()
    };

    nodes.forEach((nodeInfo, index) => {
      const parts = nodeInfo.node.toLowerCase().split(/[_-]/);
      const type = nodeInfo.type;
      if (!nodeKeywordMap[type]) return;
      for (const part of parts) {
        if (!nodeKeywordMap[type].has(part)) {
          nodeKeywordMap[type].set(part, new Set());
        }
        nodeKeywordMap[type].get(part).add({
          index,
          parts,
          data: nodeInfo
        });
      }
    });

    for (const [key, pinInfo] of chipInfo.pins.entries()) {
      const pinNet = pinInfo.net.toLowerCase();
      if (!pinNet) continue;
      const isPower = powerSet.has(pinNet);
      const isReference = refSet.has(pinNet);
      if (!isPower && !isReference) continue;
      const parts = key.toLowerCase().split(/[_-]/);
      const nodeType = isPower ? 'Power' : 'Ground';
      let matchedNode = null;
      for (const part of parts) {
        const partNodes = nodeKeywordMap[nodeType].get(part);
        if (!partNodes) continue;
        for (const node of partNodes) {
          if (usedNodeIndexes.has(node.index)) continue;
          matchedNode = node;
          break;
        }
        if (matchedNode) break;
      }

      if (matchedNode) {
        usedNodeIndexes.add(matchedNode.index);
        const { data } = matchedNode;
        cpmPairs.push({
          csmNet: data.net,
          node: data.node,
          portName: data.portName,
          pin: pinInfo.pin,
          net: pinInfo.net
        });
      }
    }

    if (cpmPairs.length / nodes.length > 0.1) {
      this.setState({
        cpmPairs,
        autoMatchStatus: SUCCESS,
        autoMatchSpan: `${SUCCESS}: Automatic matching is success (By Pin Number), there are ${nodes.length} Nodes in the CPM, and ${cpmPairs.length} Nodes are successfully matched.`
      })
    } else {
      this.setState({
        cpmPairs: [],
        autoMatchStatus: ERROR,
        autoMatchSpan: `${ERROR}: Automatic matching failed (By Pin Number). Please edit CPM Connection to match manually.`
      })
    }
  }

  getAutoMatchMsgClass = () => {
    const { autoMatchStatus } = this.state;
    switch (autoMatchStatus) {
      case SUCCESS:
        return 'cpm-setup-success-msg';
      case ERROR:
        return 'cpm-setup-error-msg';
      case LOADING:
        return 'cpm-setup-loading-msg';
      case NONE:
      default:
        break;
    }
  }

  getAutoMatchMsgIcon = () => {
    const { autoMatchStatus } = this.state;
    switch (autoMatchStatus) {
      case SUCCESS:
        return <CheckCircleOutlined />;
      case ERROR:
        return <CloseCircleOutlined />;
      case LOADING:
        return <LoadingOutlined />;
      case NONE:
      default:
        break;
    }
  }

  csmCpmSelectContent = () => {
    const { onDieSpiceList, customSpiceList, product } = this.props;
    const { subcktList, readSelectFile, readSubcktList, writeSelectFile } = this.state;
    const csmCpmSpiceList = product === CASCADE ?
      customSpiceList.map(item => { return item.format === 'Folder' ? { ...item, type: 'folder' } : item; }) :
      onDieSpiceList.filter(item => item.type === 'folder');
    let writeDisable
    if (product === CASCADE) {
      writeDisable = writeSelectFile && writeSelectFile.libraryId && !(
        csmCpmSpiceList.find(item => item.id === writeSelectFile.libraryId) ||
        csmCpmSpiceList.find(item =>
          item.children && item.children.find(file => file.id === writeSelectFile.libraryId)
        )
      ) ? true : false;
    } else {
      writeDisable = writeSelectFile && writeSelectFile.libraryId && !csmCpmSpiceList.find(item => item.id === writeSelectFile.libraryId) ? true : false;
    }
    const readDisable = readSelectFile && readSelectFile.libraryId && !csmCpmSpiceList.find(item => item.id === readSelectFile.libraryId) ? true : false;
    return <Fragment>
      <div className={product === CASCADE ? 'cascade-csm-content-item' : 'csm-content-item'}>
        <span>{product === CASCADE ? 'Model' : 'Write Model'}   </span>
        <TreeSelect
          showSearch
          value={writeSelectFile && writeSelectFile.fileName ? `${writeSelectFile.fileName}` : null}
          onSelectItem={this.changeSelectModel}
          className={writeDisable ? "aurora-select cpm-select-disable" : 'aurora-select'}
          popupClassName="aurora-select-dropdown"
          popupMatchSelectWidth={false}
          allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => { this.changeSelectModel() }} /> }}
          getPopupContainer={() => document.getElementById('root')}
          fileList={csmCpmSpiceList}
          size='small'
          suffixIcon={writeDisable ? <Tooltip
            title={`The corresponding package was not found, please choose again.`}
            classNames={{ root: 'aurora-tooltip' }}
          ><QuestionCircleOutlined className='aurora-file-check-icon' /></Tooltip> : null}
          selected={writeSelectFile && writeSelectFile.fileName ? `${writeSelectFile.libraryId}::${writeSelectFile.fileName}` : null}
        />
      </div>
      <div className={product === CASCADE ? 'cascade-csm-content-subckt-item' : 'csm-content-subckt-item'}>
        <Select
          className='aurora-select'
          popupClassName="aurora-select-dropdown"
          onSelect={this.changeSelectModelSubckt}
          value={writeSelectFile && writeSelectFile.subckt ? writeSelectFile.subckt : ""}
          size='small'
          showSearch={true}
          popupMatchSelectWidth={false}
          options={(subcktList || []).map(item => ({ value: product === CASCADE ? item.name : item, label: product === CASCADE ? item.name : item }))}
        />
      </div>
      {product !== CASCADE && <Fragment>
        <div className='csm-content-item'>
          <span>Read Model</span>
          <TreeSelect
            showSearch
            value={readSelectFile && readSelectFile.fileName ? `${readSelectFile.fileName}` : null}
            onSelectItem={(value) => this.changeSelectModel(value, READ)}
            className={readDisable ? "aurora-select cpm-select-disable" : 'aurora-select'}
            popupClassName="aurora-select-dropdown"
            popupMatchSelectWidth={false}
            allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => { this.changeSelectModel(null, READ) }} /> }}
            getPopupContainer={() => document.getElementById('root')}
            fileList={csmCpmSpiceList}
            size='small'
            suffixIcon={readDisable ? <Tooltip
              title={`The corresponding package was not found, please choose again.`}
              classNames={{ root: 'aurora-tooltip' }}
            ><QuestionCircleOutlined className='aurora-file-check-icon' /></Tooltip> : null}
            selected={readSelectFile && readSelectFile.fileName ? `${readSelectFile.libraryId}::${readSelectFile.fileName}` : null}
          />
        </div>
        <div className='csm-content-subckt-item'>
          <Select
            className='aurora-select'
            popupClassName="aurora-select-dropdown"
            onSelect={(value) => this.changeSelectModelSubckt(value, READ)}
            value={readSelectFile && readSelectFile.subckt ? readSelectFile.subckt : ""}
            size='small'
            showSearch={true}
            popupMatchSelectWidth={false}
            options={(readSubcktList || []).map(item => ({ value: item, label: item }))}
          />
        </div>
      </Fragment>}
    </Fragment>
  }

  csmSelectContent = () => {
    const { modelType, onDieSpiceList } = this.props;
    const { selectFile } = this.state;
    const csmCpmSpiceList = onDieSpiceList.filter(item => item.type === "folder");
    return <Fragment>
      <div className='csm-cpm-content-item csm-cpm-content-item-flex'>
        <span>{modelType} Model</span>
        <Select
          className='aurora-select'
          popupClassName="aurora-select-dropdown"
          onSelect={this.changeSelectModel}
          value={selectFile && selectFile.fileName ? `${selectFile.libraryId}::${selectFile.fileName}` : null}
          size='small'
          showSearch={true}
        >
          {(csmCpmSpiceList || []).map(folder =>
            <OptGroup key={folder.id} label={folder.name}>
              {(folder.children || []).map(item =>
                <Option
                  key={`${folder.id}::${item.fileName}`}
                  value={`${folder.id}::${item.fileName}`}
                  className={selectFile && selectFile.fileName && selectFile.libraryId === folder.id && selectFile.fileName === item.fileName ? "ant-select-dropdown-menu-item-selected" : ""}
                >{item.fileName}</Option>
              )}
            </OptGroup>
          )}
        </Select>
      </div>
    </Fragment>
  }

  getTable = () => {
    const { pairs } = this.state;
    return <EditableTable
      rowKey={(record) => record.pin}
      columns={this.getTableColumns()}
      size="small"
      selectType="node"
      className="cpm-select-model-pairs-table"
      dataSource={JSON.parse(JSON.stringify(pairs))}
    />
  }

  render = () => {
    const { modelType, packageId, packageChannelId, pcb, SignalNets, product, rockyPackageInfo, isUpdateSsnPackageChannel, pcbChannelInfo, content, pinsInfo, DesignInfo, isPostPkgLayout } = this.props;
    const { selectFile, cpmVisible, component, PowerNets, ReferenceNets, csmVisible,
      csmPairs, triPairs, transforms, cpmPairs = [], canvasFile, readSelectFile, writeSelectFile, loading, autoMatchStatus, autoMatchSpan } = this.state;
    return <Spin spinning={loading}>
      <div className='csm-cpm-content'>
        {this.csmCpmSelectContent()}
        {product !== CASCADE || isPostPkgLayout && <div className="csm-cpm-content-item">
          <span>{`${modelType} Connection`}</span>
          <EditOutlined
            className="csm-cpm-content-icon"
            onClick={(e) => this.openCPMConnection(e, true)}
          />
        </div>}
        {product === CASCADE && (!isPostPkgLayout || cpmPairs.length) ? this.getTable() : null}
        {/* {product === CASCADE && autoMatchStatus !== NONE ? <div className='cpm-auto-match-content-item'>
          <div className={`cpm-setup-msg ${this.getAutoMatchMsgClass()}`}>
            {this.getAutoMatchMsgIcon()}
            {autoMatchSpan}
          </div>
        </div> : null} */}
        {/* {modelType === CSM ? <div className='csm-cpm-content-item'>
          <span>CSM Instance Mapping</span>
          <Icon type="edit" className='csm-cpm-content-icon' onClick={(e) => this.openCSMMapping(e, true)} />
        </div> : null} */}
        {cpmVisible ? <CPMConnection
          designId={packageId}
          component={component}
          PowerNets={PowerNets}
          ReferenceNets={ReferenceNets}
          selectFile={selectFile}
          triPairs={triPairs}
          transforms={transforms}
          cpmPairs={cpmPairs}
          canvasFile={canvasFile}
          closePanel={() => this.openCPMConnection(null, false)}
          saveCPMPinMapping={this.saveCPMPinMapping}
          SignalNets={SignalNets}
          readSelectFile={readSelectFile}
          writeSelectFile={writeSelectFile}
          getPortList={getWriteAndReadPortList}
          csmPairs={csmPairs}
          pcb={pcb}
          isUpdateFile={true}
          modelType={modelType}
          product={product}
          pcbChannelInfo={pcbChannelInfo}
          isUpdateSsnPackageChannel={isUpdateSsnPackageChannel}
          content={content}
          pinsInfo={pinsInfo}
          getCSMCPMSpiceModelList={this.props.getCSMCPMSpiceModelList}
          DesignInfo={DesignInfo}
        /> : null}
        {csmVisible ? <CSMSignalsConnection
          designId={packageId}
          component={component}
          selectFile={selectFile}
          csmPairs={csmPairs}
          packageChannelId={packageChannelId}
          saveCSMPairs={this.saveCSMPairs}
          closePanel={() => this.openCSMMapping(null, false)}
          readSelectFile={readSelectFile}
          writeSelectFile={writeSelectFile}
          getPortList={getWriteAndReadPortList}
          pcb={pcb}
          rockyPackageInfo={rockyPackageInfo}
          isUpdateSsnPackageChannel={isUpdateSsnPackageChannel}
          pcbChannelInfo={pcbChannelInfo}
          content={content}
          updateSSNPackageInfo={updateSSNPackageInfo}
        /> : null}
      </div>
    </Spin >
  }
}

export default CPMCSMContent;